import { api } from './api';
import { API_BASE } from './apiBase';

export type TeamRole = 'owner' | 'admin' | 'member';

export interface TeamMember {
  id: number;
  email: string;
  contactPerson: string;
  teamRole: TeamRole;
  isVerified: boolean;
  createdAt: string;
}

export interface TeamDto {
  id: number;
  name: string;
  ownerId: number;
  letterhead: string | null;
  addonLogoEnabled: boolean;
  hasLogo: boolean;
  logoUrl: string | null;
  members: TeamMember[];
}

export interface TeamInvitation {
  id: number;
  teamId: number;
  invitedBy: number;
  email: string;
  role: 'admin' | 'member';
  token: string;
  expiresAt: string;
  acceptedAt: string | null;
  createdAt: string;
}

export interface IncomingInvitation {
  id: number;
  teamId: number;
  teamName: string;
  inviterName: string;
  role: string;
}

export interface PublicInvitationInfo {
  teamName: string;
  inviterName: string;
  role: string;
  alreadyAccepted: boolean;
}

export const teamsApi = {
  getMyTeam: () => api.get<TeamDto>('/api/team'),
  updateName: (name: string) => api.patch<void>('/api/team', { name }),
  invite: (email: string, role: 'admin' | 'member') =>
    api.post<TeamInvitation>('/api/team/invitations', { email, role }),
  listInvitations: () => api.get<TeamInvitation[]>('/api/team/invitations'),
  listIncomingInvitations: () => api.get<IncomingInvitation[]>('/api/team/invitations/incoming'),
  revokeInvitation: (id: number) => api.delete<void>(`/api/team/invitations/${id}`),
  acceptInvitation: (token: string) => api.post<{ teamId: number }>(`/api/team/accept/${token}`, {}),
  removeMember: (userId: number) => api.delete<void>(`/api/team/members/${userId}`),
  changeRole: (userId: number, role: 'admin' | 'member') =>
    api.patch<void>(`/api/team/members/${userId}`, { role }),
  leave: () => api.post<void>('/api/team/leave', {}),
  getInvitationByToken: async (token: string): Promise<PublicInvitationInfo> => {
    const resp = await fetch(`${API_BASE}/api/team-public/invitation/${token}`);
    if (!resp.ok) {
      const data = await resp.json().catch(() => ({}));
      throw new Error(data.message || 'Einladung nicht gefunden');
    }
    return resp.json();
  },
};
